import Vue from 'vue';


import Calc from './components/calculator/invests.vue';

new Vue({
  el: '#entry-point',
  render: function (h) {
    return h(Calc);
  }
});
